import { Injectable } from '@angular/core';
import {
  DEFAULT_ALIGN,
  DEFAULT_ORDER_BY,
  DEFAULT_PAGE_NUMBER,
  DEFAULT_PAGE_SIZE,
  DEFAULT_QUERY,
} from '../consts';
import type { GridStorageState } from '../types/storage.type';

/**
 * 로컬스토리지에 그리드 상태를 저장하고 불러오는 서비스
 */
@Injectable({ providedIn: 'root' })
export class GridStorageService {
  /**
   * 상태를 로컬스토리지에 저장합니다
   */
  public saveState(key: string, state: GridStorageState): void {
    try {
      localStorage.setItem(key, JSON.stringify(state));
    } catch (error) {
      console.warn('Failed to save grid state to localStorage:', error);
    }
  }

  /**
   * 로컬스토리지에서 상태를 불러옵니다.
   * 저장된 값이 없거나 유효하지 않은 경우 기본값을 반환합니다.
   */
  public loadState(key: string): GridStorageState | null {
    try {
      const stored = localStorage.getItem(key);
      if (!stored) return null;

      const parsed = JSON.parse(stored);
      return {
        pageNo: parsed.pageNo ?? DEFAULT_PAGE_NUMBER,
        pageSize: parsed.pageSize ?? DEFAULT_PAGE_SIZE,
        query: parsed.query ?? DEFAULT_QUERY,
        align: parsed.align ?? DEFAULT_ALIGN,
        orderBy: parsed.orderBy ?? DEFAULT_ORDER_BY,
      };
    } catch (error) {
      console.warn('Failed to load grid state from localStorage:', error);
      return null;
    }
  }

  /**
   * 로컬스토리지에서 상태를 삭제합니다
   */
  public clearState(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.warn('Failed to clear grid state from localStorage:', error);
    }
  }
}
